import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const HowItWorksDesktop = loadable(() => import("./HowItWorksDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <HowItWorksDesktop {...props} />
  </ErrorBoundary>
);
